export const BYCE_PROGRAM_SLUG = "building-your-clinical-ear-program";

export const availabilityLabel = value => ({
  available: "Available",
  derivable_projection_missing: "Projection pending",
  not_yet_captured: "Not available yet",
  methodology_pending: "Methodology pending",
  sample_pending: "Sample pending",
}[value] || "Not available yet");

export const componentByKey = (evidence, key) =>
  evidence?.components?.find(component => component.key === key) || null;

export const componentValue = (evidence, key) => {
  const component = componentByKey(evidence, key);
  if (!component) return "Not available yet";
  if (component.type === "metric") return `${component.value}${component.unit ? ` ${component.unit}` : ""}`;
  if (component.type === "status") return availabilityLabel(component.value);
  return "Available";
};

export const reflectionValue = evidence => {
  const component = componentByKey(evidence, "reflection-evidence");
  if (component?.type !== "metric") return componentValue(evidence, "reflection-evidence");
  return component.value > 0 ? "Submitted" : "Not submitted";
};

export const participantStatusValue = (evidence, key) => {
  const component = componentByKey(evidence, key);
  if (!component) return "Not available yet";
  return component.type === "metric" ? componentValue(evidence, key) : "Not available yet";
};

export const finalRatingValue = (evidence, progress) => {
  const component = componentByKey(evidence, "capstone");
  if (component?.type === "metric") return componentValue(evidence, "capstone");
  if (progress?.applicabilityState === "completed") return "Not available yet";
  const stage = currentStageLabel(progress);
  return stage.startsWith("Stage 4") ? "Not available yet" : "Not started";
};

export const finalRatingExecutionValue = progress => {
  if (progress?.applicabilityState === "completed") return "Completed";
  return currentStageLabel(progress).startsWith("Stage 4") ? "In progress" : "Not started";
};

export const developmentResultItems = evidence =>
  componentByKey(evidence, "development-reference-range-results")?.items || [];

export const completedSessionDateItems = evidence =>
  componentByKey(evidence, "completed-session-dates")?.items || [];

export const developmentResultSummary = evidence => {
  const inside = componentByKey(evidence, "development-inside-range")?.value;
  const submitted = componentByKey(evidence, "development-submitted-ratings")?.value;
  return Number.isFinite(inside) && Number.isFinite(submitted)
    ? `${inside} of ${submitted} submitted ratings within the expert range`
    : "Not available yet";
};

export const BYCE_OUTCOME_WEIGHTS = Object.freeze([
  { key: "session-completion", label: "Session completion", points: 8 },
  { key: "spacing", label: "Spacing", points: 6 },
  { key: "consistency", label: "Consistency checks", points: 4 },
  { key: "reflection", label: "Reflection", points: 4 },
  { key: "final-rating", label: "Final rating", points: 8 },
]);

export const stageItems = evidence => componentByKey(evidence, "stage-progress")?.items || [];

export const currentStageLabel = progress =>
  progress?.currentAttempt?.currentStage?.label ||
  (progress?.applicabilityState === "completed" || progress?.currentAttempt?.state === "completed" ||
    progress?.historicalAttempts?.some(attempt => attempt.state === "completed")
    ? "Completed"
    : progress?.currentAttempt ? "Current stage unavailable" : "Not started");
